const visionPillars = [
  {
    icon: 'ri-global-line',
    title: 'Global Partnership',
    desc: 'Building trusted relationships with organizations worldwide to facilitate responsible AI adoption and digital transformation at scale',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Responsible Innovation',
    desc: 'Ensuring ethical implementation of intelligent systems with compliance frameworks that protect stakeholders and drive sustainable growth',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Accessible Brilliance',
    desc: 'Making evidence-based digital health solutions accessible through strategic consulting and technical implementation support for all',
  },
];

export default function VisionSection() {
  return (
    <section className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #09090f 0%, #0e0e1a 100%)' }}>
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-8">
        <div className="w-[800px] h-[500px] rounded-full" style={{ background: 'radial-gradient(ellipse, rgba(201,168,76,0.12) 0%, transparent 70%)' }} />
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
            Our Vision
          </span>
          <h2 className="text-4xl font-bold text-white mb-8 tracking-tight">
            The Future We&apos;re{' '}
            <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Engineering
            </span>
          </h2>
          <div
            className="relative max-w-4xl mx-auto p-8 md:p-12"
            style={{ background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '12px' }}
          >
            <i className="ri-double-quotes-l absolute top-6 left-6 text-4xl opacity-20" style={{ color: '#c9a84c' }} />
            <blockquote className="text-xl md:text-2xl font-light text-white/75 leading-relaxed italic">
              To be the trusted global partner that transforms how organizations integrate artificial intelligence and digital technologies. We envision a future where every industry leverages intelligent systems responsibly, where digital transformation drives sustainable innovation, and where personalized wellbeing solutions are accessible to all through evidence-based science and strategic implementation.
            </blockquote>
            <i className="ri-double-quotes-r absolute bottom-6 right-6 text-4xl opacity-20" style={{ color: '#c9a84c' }} />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {visionPillars.map((p) => (
            <div
              key={p.title}
              className="text-center p-8 transition-all duration-300"
              style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.12)', borderRadius: '12px' }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center mx-auto mb-5"
                style={{ background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '10px' }}
              >
                <i className={`${p.icon} text-2xl`} style={{ color: '#c9a84c' }} />
              </div>
              <h3 className="text-lg font-semibold text-white/90 mb-3 tracking-wide">{p.title}</h3>
              <p className="text-sm text-white/45 font-light leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
